import { createContext, memo, ReactNode, useContext } from 'react'
import { Tenant } from '@finanzcheck/teal-mui-theme'

interface TenantContextType {
  tenant: Tenant
}

export const TenatContext = createContext<TenantContextType>({
  tenant: Tenant.Finanzcheck,
})

export const TenantProvider = memo<{
  tenant: Tenant
  children: ReactNode
}>(({ children, tenant }) => (
  <TenatContext.Provider value={{ tenant }}>{children}</TenatContext.Provider>
))

TenantProvider.displayName = 'TenantProvider'

export const useTenant = () => useContext(TenatContext)

export const useIsSmavaTenant = () => {
  const { tenant } = useTenant()

  return tenant === Tenant.Smava
}
